import { Loader } from "react-feather";
import { IconSaveSVG } from "../../icon";
import { __ } from '@wordpress/i18n';

const SaveButton = ( { isSave, isSaved, onSave }) => {
    return (
        <div className={`f-theme-content-save save ${isSave ? 'load' : ''} ${isSaved ? 'saved' : ''}`} onClick={() => {
            onSave();
        }}>
            {isSaved ? <>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 21 20" fill="none">
                        <path d="M16.6673 5L7.50065 14.1667L3.33398 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {__('Saved', 'jeg-elementor-kit')}
                </span>
            </> : isSave ? <div className="loading">
                <Loader size={20} />
            </div> : <><IconSaveSVG /><span>{__('Save changes', 'jeg-elementor-kit')}</span></>}
        </div>
    );
}


export default SaveButton;